import { Component, Input } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { ValidationHeaderComponent } from '../validation-header/validation-header.component';
import { ValidateDrugMatchFormComponent } from '../validate-drug-match-form/validate-drug-match-form.component';

@Component({
    selector: 'app-validate-drug-match',
    templateUrl: './validate-drug-match.component.html',
    styleUrls: ['./validate-drug-match.component.scss'],
    imports: [ValidationHeaderComponent, ValidateDrugMatchFormComponent]
})
export class ValidateDrugMatchComponent {
  collapsed = false;

  @Input() patientAttachment: PatientAttachment;

  constructor() {}

  onCollapseChange(collapsed) {
    this.collapsed = collapsed;
  }

  collapse() {
    this.collapsed = true;
  }

  expand() {
    this.collapsed = false;
  }
}
